import React from 'react';
import Logo from '../../src/Images/dsom-logo-footer.png';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import * as PATH from '../CentralisedLink';
import { useFeatureFlags } from '../FeatureFlags/FeatureFlagsContext';
import { FEATURE_FLAGS } from '../FeatureFlags/featureFlagConstants';

const FooterBlock = () => {
  let footerLinks;
  const currentUser = useSelector(state => state.auth?.currentUser);
  const canDemo = currentUser?.canDemo;
  const { isFeatureEnabled } = useFeatureFlags();
  const shouldShowDemoIngestionsNav = isFeatureEnabled(FEATURE_FLAGS.EnableDemoIngestions);
  const shouldShowBookingNav = isFeatureEnabled(FEATURE_FLAGS.EnableBookings);
  const shouldShowContentStoreNav = isFeatureEnabled(FEATURE_FLAGS.EnableContentStore);
  const shouldShowEnablementNav = isFeatureEnabled(FEATURE_FLAGS.EnableEnablement);
  const shouldShowFaqNav = isFeatureEnabled(FEATURE_FLAGS.EnableFAQ);


  if (canDemo === false) {
    footerLinks =
      <>
        <div className="row row-cols-md-5 row-cols-sm-2 align-items-center">

          <div className="col-md-2 col-sm-6">
            <ul>
              {shouldShowContentStoreNav && (
                <li className='footer-list-item'>
                  <Link to={`${PATH.CONTENT_STORE_PATH}`} style={{ textDecoration: 'none', color: '#fff' }}>Content Store</Link>
                </li>
              )}
              {shouldShowFaqNav && (
                <li className='footer-list-item'>
                  <Link to={`${PATH.FAQ_PATH}`} style={{ textDecoration: 'none', color: '#fff' }}>FAQ</Link>
                </li>
              )}
            </ul>
          </div>
          <div className="col-md-3 col-sm-6">
            <ul>
              {shouldShowEnablementNav && (
                <li className='footer-list-item'>
                  <Link to={`${PATH.LEARNING_HUB_PATH}`} style={{ textDecoration: 'none', color: '#fff' }}>Learning Hub</Link>
                </li>
              )}
            </ul>
          </div>
          <div className="col-md-2 col-sm-6"></div>
          <div className="col-md-2 col-sm-12">
            <img className="footer-logo" src={Logo} alt="Demo Central Logo" />
          </div>
        </div>
      </>
  } else {
    footerLinks =
      <>
        <div className="row row-cols-md-5 row-cols-sm-2 align-items-center">
          <div className="col-md-3 col-sm-6">
            <ul>
              {shouldShowDemoIngestionsNav && (
                <li className='footer-list-item'>
                  <Link to={`${PATH.DEMO_CATALGUE_PATH}`} style={{ textDecoration: 'none', color: '#fff' }}>Demo Catalogue</Link>
                </li>
              )}
              {shouldShowDemoIngestionsNav && (
                <li className='footer-list-item'>
                  <Link to={`${PATH.RESET_PATH}`} style={{ textDecoration: 'none', color: '#fff' }}>Demo Reset</Link>
                </li>
              )}
            </ul>
          </div>
          <div className="col-md-2 col-sm-6">
            <ul>
              {shouldShowContentStoreNav && (
                <li className='footer-list-item'>
                  <Link to={`${PATH.CONTENT_STORE_PATH}`} style={{ textDecoration: 'none', color: '#fff' }}>Content Store</Link>
                </li>
              )}
              {shouldShowFaqNav && (
                <li className='footer-list-item'>
                  <Link to={`${PATH.FAQ_PATH}`} style={{ textDecoration: 'none', color: '#fff' }}>FAQ</Link>
                </li>
              )}
            </ul>
          </div>
          <div className="col-md-3 col-sm-6">
            <ul>
              {shouldShowEnablementNav && (
                <li className='footer-list-item'>
                  <Link to={`${PATH.LEARNING_HUB_PATH}`} style={{ textDecoration: 'none', color: '#fff' }}>Learning Hub</Link>
                </li>
              )}
              {shouldShowBookingNav && (
                <li className='footer-list-item'>
                  <Link to={`${PATH.BOOKING_PATH}`} style={{ textDecoration: 'none', color: '#fff' }}>Booking</Link>
                </li>
              )}
            </ul>
          </div>
          <div className="col-md-2 col-sm-6"></div>
          <div className="col-md-2 col-sm-12">
            <img className="footer-logo" src={Logo} alt="Demo Central Logo" />
          </div>
        </div>
      </>
  }



  return (


    <footer id='footer-style'>
      <div className='container' id='footer-container'>
        <h6 className='quick-links'>Quick Links</h6>


        {footerLinks}


        <hr></hr>
        <p className='copyright-text'>© Copyright 2026 BMC Helix</p>
      </div>
    </footer>

  );
}

export default FooterBlock;
